module.exports = __webpack_public_path__ + "static/media/3playerRoomsPlayed_10_50.2485f318.png";